var emailPattern = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
);
onmessage = function (e) {
  if (e.data.type === "webpackOk") return;
  var postMessageTarget = e.data.XssSafeWorker ? window.top : this;
  var rows, order, context;
  // Allow for passing in rows as an array without an order
  if (Array.isArray(e.data)) {
    rows = e.data;
    order = {};
  } else {
    rows = e.data.rows;
    order = e.data.order;
    context = e.data.context; // this is window.per
  }
  // If we do have an order object `{ id: order }`, we resort the data accordingly
  if (typeof order !== "undefined" && Object.keys(order).length) {
    rows.sort(function (a, b) {
      return order[a.id] - order[b.id];
    });
  }

  var distanceIndex = null;
  var lastIndex = context.columnNames.length - 1;
  if (
    context &&
    context.columnNames.length &&
    context.columnNames[lastIndex].toLowerCase() === "distance"
  ) {
    distanceIndex = lastIndex;
  }

  var tableData = [];
  if (rows && rows.length) {
    var columnTypes = rows[0].data.map(function (data) {
      // Check for a date first. Check if it's at least 6 digits which is the
      // shortest date you could have like 1/1/90 or 1-1-90 then check to make
      // sure it's not just numbers. Jan 1, 1/1 would be OK, but 0101 we'll treat
      // as a number. Finally, make sure that we can parse whatever we gave
      if (
        data.length >= 6 &&
        /^[\d-/]+$/.test(data) &&
        !isNaN(Date.parse(data))
      ) {
        return "date";
      }
      // If no on that, check if it's a number
      else if (!isNaN(Number(data))) {
        return "number";
      }
      // Check for hyperlinks
      else if (data.includes("http")) {
        return "hyperlink";
      }
      // Check for email addresses
      else if (emailPattern.test(data)) {
        return "email";
      }
      // Everything else return as a string
      else {
        return "string";
      }
    });

    rows.forEach(function (row) {
      var noMarkerClass = "";
      // if row has map data but no lat/long then designate no marker
      if (row.map && (!row.map.ln || !row.map.lt)) {
        noMarkerClass = 'class="row-no-marker"';
      }

      var rowHtml = '<tr data-id="' + row.id + '" ' + noMarkerClass + ">";

      row.data.forEach(function (cell, cellIndex) {
        if (cellIndex === distanceIndex) {
          cell += ` ${context.dist_sel === 0 ? "mi" : "km"}`;
        }
        const type = columnTypes[cellIndex];
        rowHtml += `<td class="data-table-cell-tooltip ${type === "email" || type === "hyperlink" ? "data-table-cell-tooltip-link" : ""}" data-text="${cell}" data-type="${columnTypes[cellIndex]}" data-position="${cellIndex}">${cell}</td>`;
      });

      rowHtml += "</tr>";
      tableData.push(rowHtml);
    });
  }

  postMessageTarget.postMessage({
    tableData: tableData,
    rows: rows || [],
  });

  close();
};
